<template>
  <drag-modal :visible="visible" @cancel="reset" title="新增沟通记录" width="860px">
    <div class="hisform">
      <a-form-model ref="forms" :model="form" :rules="rules" :label-col="{ span: 3 }" :wrapper-col="{ span: 10 }">
        <a-form-model-item label="我方人员" prop="uname">
          <a-input v-model="form.uname" disabled/>
        </a-form-model-item>
        <a-form-model-item label="对方人员" prop="adversary">
          <a-input v-model="form.adversary" :disabled="see" />
        </a-form-model-item>
        <a-form-model-item label="沟通方式" prop="type">
          <a-select placeholder="请选择沟通方式" v-model="form.type" :disabled="see" :allowClear='true' >
            <a-select-option :value="i.value" v-for="(i, index) in typeList" :key="index">
              {{ i.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="联系方式" prop="tel">
          <a-input type="text" v-model="form.tel" placeholder="请输入" :disabled="see"></a-input>
        </a-form-model-item>
        <a-form-model-item label="沟通内容" prop="content" :wrapper-col="{ span: 20 }">
          <a-input type="textarea" v-model="form.content" placeholder="请输入" :disabled="see"></a-input>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 24 }">
          <Upload :fList="List" @upFileAfter="lisUpload" :Wid="'102px'" :edit="see" />
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 16, offset: 7 }" v-if="!see">
          <a-popconfirm title="确认提交此条数据吗?" ok-text="确定" cancel-text="取消" @confirm="sub">
            <a-button type="primary" style="width: 148px"> 保存 </a-button>
          </a-popconfirm>
          <a-button style="margin-left: 20px; width: 148px; background: #b2c9e1; color: #fff;" @click="reset">取消</a-button>
        </a-form-model-item>
      </a-form-model>
    </div>
  </drag-modal>
</template>

<script>
  import { LHis } from '@/server/api'
  import Upload from '@/components/uploads'
  export default {
    name:"His",
    props: {
      info: {
        type: Object,
        default () {
          return {}
        },
      },
    },
    watch: {
      info: {
        handler(newVal) {
          if (newVal.id) {
            this.form = {
              id: newVal.id,
              uname: newVal.uname,
              adversary: newVal.adversary,
              content: newVal.content,
              type: newVal.type,
              tel:newVal.tel
            }
            newVal.files.map((ele) => {
              ele.title = ele.origin_name
              ele.upload_id = ele.id
            })
            this.file = newVal.files.map((ele) => {
              return ele.id
            })
            this.edit=true
            this.List = newVal.files
            this.see = newVal.see
          } else {
            this.form = {
              
            }
            this.list=[]
            this.file=[]
            this.form.uname = this.$store.state.user.uname;
            this.edit = false
          }
        },
        immediate: true,
        deep:true
      },
    },
    data() {
      return {
        List: [],
        comment: [],
        typeList: [
          {name: '现场',value:1},
          {name: '电话',value:2},
          {name: '短信',value:3},
          {name: '微信',value:4},
        ],
        see:false,
        form: {},
        edit: false,
        file: [],
        rules: {
          type: [{required: true,message: '请选择沟通方式',trigger: 'change'}],
          uname: [{ required: true,message: '请输入我方人员',trigger: 'blur'}],
          adversary: [{ required: true,trigger:'blur',message: '请输入对方人员'}],
          content: [{required: false, trigger: 'blur',message: '请输入沟通内容' }],
        },
        visible: false,
      }
    },
    components:{Upload},
    methods: {
      lisUpload(fileList) {
        this.file = fileList
      },
      sub() {
        let form = JSON.parse(JSON.stringify(this.form))
        form.letters_debtor_id=this.$route.params.id
        form.files = this.file
        LHis(this.edit?'edit':'add',form).then(()=>{
          this.$message.success((this.edit?'修改':'新增')+'成功')
          this.$emit('resh')
          this.reset()
        })
      },
      reset() {
        this.$refs.forms.resetFields()
        this.visible=false
      },
    },
  }
</script>

<style lang="less">
  .hisform {
    textarea {
      width: 100%;
      height: 80px;
      border: 1px solid #efefef;
      padding: 4px 10px;
    }
  }
</style>
